module.exports = __webpack_public_path__ + "media/application/images/logo-18cb69f3bdf85bb6f6085753d42624eb.png";